<table class="userManagementSites__table" [@openClose]="isOpen ? 'open' : 'closed'">
  @for (
    share of ppUser.shares; track trackByFunction(index,
    share); let index = $index; let last = $last) {
    <pp-user-management-site-row
      [ppCustomFields]="ppCustomFields"
      [ppIndex]="index"
      [ppShare]="share"
      [ppLast]="last"
      (ppNavigate)="navigateToSite($event)"
    ></pp-user-management-site-row>
  }
</table>
